<div class="modal-header">
  <h6 class="modal-title" id="exampleModalLabel"><strong>{{header}}</strong></h6>
      <button type="button" (click)="closeAllModal()" class="btn-close" aria-label="Close"></button>
</div>
<div class="modal-body overflow-auto" style="height: 200px;">
  <p>Below listed records are not matched with our database. Only matched records will be uploaded. Do you still want to continue?</p>
  <div *ngIf="invalidRecords.length > 0" class="mt-2">
    <div class="col-lg-8"  id="bulkuploadBody">
      <table class="table table-bordered">
        <tr><th>GPN</th><th>GUI</th></tr>
        <tbody>
          <tr *ngFor="let item of invalidRecords"><td>{{item.gpn}}</td><td>{{item.gui}}</td></tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button (click)="closeAllModal()" type="button" class="btn btn-primary" data-dismiss="modal">No</button>
  <button (click)="upload()" type="button" class="btn btn-secondary">Yes</button>
</div>
